module.exports = __webpack_public_path__ + "img/project-diagram.696928d4.svg";